import { CompanyCollection } from './CompanyCollection';
import { Company } from './Company';
import { CompanyTypeEnum } from './CompanyTypeEnum';
import * as firebase from 'firebase'

export class CompanyService {
  private collection: CompanyCollection;

  private companies = new Map<string, Company>();
  private companiesBySevenFiftyId = new Map<number, Company>();
  private byType = new Map<CompanyTypeEnum, Company[]>();

  constructor(db: firebase.firestore.Firestore) {
    this.collection = new CompanyCollection(db);
  }

  public watchCompaniesByType(
    type: CompanyTypeEnum,
    cb?: (list: Company[], unsub?: (() => void) | undefined) => void
  ): Company[] {
    if (!this.byType.has(type)) {
      this.byType.set(
        type,
        this.collection.watchCompaniesByType(type)
      );
    }

    return this.byType.get(type) as Company[];
  }

  async getCompany(id: string): Promise<Company | null> {
    if (!this.companies.has(id)) {
      const company = await this.collection.getCompany(id);

      if (!company) {
        return null;
      }

      this.cacheCompany(company)
    }

    return this.companies.get(id) as Company;
  }

  async getCompanyBySevenFiftyId(sevenFiftyId: number): Promise<Company | null> {
    if (!this.companiesBySevenFiftyId.has(sevenFiftyId)) {
      const company = await this.collection.getCompanyBySevenFiftyId(sevenFiftyId);

      if (!company) {
        return null;
      }

      this.cacheCompany(company)
    }

    return this.companiesBySevenFiftyId.get(sevenFiftyId) as Company;
  }

  async getVendorCompanyBySevenFiftyId(sevenFiftyId: number): Promise<Company | null> {
    if (!this.companiesBySevenFiftyId.has(sevenFiftyId)) {
      const company = await this.collection.getVendorCompanyBySevenFiftyId(sevenFiftyId);

      if (!company) {
        return null;
      }

      this.cacheCompany(company)
    }

    return this.companiesBySevenFiftyId.get(sevenFiftyId) as Company;
  }

  cacheCompany(company: Company) {
    this.companies.set(company.id, company);
    if (company.externalIds && typeof company.externalIds.sevenFifty === 'number') {
      this.companiesBySevenFiftyId.set(company.externalIds.sevenFifty, company);
    }
  }
}
